import { DraftReturnSchema } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const addMerchantOverrides = {
  name: "addMerchantOverrides" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    adjustmentOverrides: z.array(
      z.object({ pendingReturnItemId: z.string(), adjustment: z.number() }),
    ),
    greenReturnOverrides: z.array(
      z.object({ pendingReturnItemId: z.string(), greenReturn: z.boolean() }),
    ),
    customerPaysReturnShipping: z.boolean(),
    customerPaysNewOrderShipping: z.boolean(),
    // Flat return-shipping charge in presentment currency; null clears it.
    flatRateShippingOverride: z.number().nullish(),
    flagReturn: z.boolean(),
    manualReview: z.boolean(),
    waiveCustomerCompensation: z.boolean(),
    waiveOutstandingBalance: z.boolean(),
    keepFeesAndBonuses: z.boolean(),
    discountCodes: z.array(z.string()),
    applyAutomaticDiscounts: z.boolean(),
    createRepairInvoice: z.boolean(),
    posInputOverrides: z.array(
      z.object({
        pendingReturnItemId: z.string(),
        restockRequested: z.boolean(),
      }),
    ),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
